import React, { useEffect, useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

const LandingPage = ({ language, setLanguage, t, animationStage }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [contactForm, setContactForm] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [contactStatus, setContactStatus] = useState('');
  const formRef = useRef(null);

  // Initialize EmailJS
  useEffect(() => {
    emailjs.init('SOkxfm4FCsbcD4ccW');
  }, []);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    setContactStatus('loading');
    try {
      await emailjs.sendForm(
        'service_7cc4qd4',
        'template_2mzxpa3',
        formRef.current,
        'SOkxfm4FCsbcD4ccW'
      );
      setContactStatus('success');
      setContactForm({ name: '', email: '', message: '' });
      setTimeout(() => setContactStatus(''), 3000);
    } catch (error) {
      console.error('Email error:', error);
      setContactStatus('error');
      setTimeout(() => setContactStatus(''), 3000);
    }
  };

  const handleContactChange = (field, value) => {
    setContactForm((prev) => ({ ...prev, [field]: value }));
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <div className="sunnysoft-container">
      {/* Navigation */}
      <nav className="sunnysoft-nav-container">
        <div className="sunnysoft-nav-content">
          <div className="sunnysoft-nav-logo">
            <img 
              src="/images/logo.png" 
              alt="SunnySoft Logo" 
              className="sunnysoft-logo-image"
              onError={(e) => { e.target.src = '/images/fallback.png'; }}
            />
          </div>
          
          <div className={`sunnysoft-nav-menu ${isMenuOpen ? 'sunnysoft-nav-menu-open' : ''}`}>
            <button onClick={() => scrollToSection('home')} className="sunnysoft-nav-link">Home</button>
            <button onClick={() => scrollToSection('services')} className="sunnysoft-nav-link">Services</button>
    <button onClick={() => scrollToSection('apps')} className="sunnysoft-nav-link">Apps</button>
<button onClick={() => scrollToSection('websites')} className="sunnysoft-nav-link">Websites</button>
<button onClick={() => scrollToSection('about')} className="sunnysoft-nav-link">About</button>
            <button onClick={() => scrollToSection('contact')} className="sunnysoft-nav-link">Contact</button>
            
      
          </div>

          <button 
            className="sunnysoft-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="sunnysoft-hero-section">
        <div className="sunnysoft-hero-background">
          <div className="sunnysoft-floating-orb sunnysoft-orb-1"></div>
          <div className="sunnysoft-floating-orb sunnysoft-orb-2"></div>
          <div className="sunnysoft-floating-orb sunnysoft-orb-3"></div>
          <div className="sunnysoft-floating-orb sunnysoft-orb-4"></div>
        </div>
        
        <div className="sunnysoft-hero-glass-card">
          <div className="sunnysoft-hero-content">
            <div className="sunnysoft-hero-badge">
              Premium Software Solutions
            </div>
            <h1 className="sunnysoft-hero-title">
              We Create
              <span className="sunnysoft-hero-accent"> Digital Excellence</span>
            </h1>
            <p className="sunnysoft-hero-subtitle">
              Cutting-edge applications, stunning websites, and innovative solutions that transform businesses. Welcome to the future of software development.
            </p>
            <div className="sunnysoft-hero-cta">
              <button onClick={() => scrollToSection('contact')} className="sunnysoft-cta-primary">
                <span>Start Project</span>
                <div className="sunnysoft-button-shine"></div>
              </button>
              <button onClick={() => scrollToSection('services')} className="sunnysoft-cta-secondary">
                <span>Explore Services</span>
              </button>
            </div>
          </div>
        </div>
      </section>
{/* Services Section */}
<section id="services" className="sunnysoft-services-section">
  <div className="sunnysoft-main-container">
    <div className="sunnysoft-section-header sunnysoft-glass-header">
      <h2 className="sunnysoft-section-title">Our Services</h2>
      <p className="sunnysoft-section-subtitle">AI-powered solutions for the digital age</p>
    </div>
    
    <div className="sunnysoft-services-grid">
      <div className="sunnysoft-service-glass-card">
        <div className="sunnysoft-service-number">01</div>
        <div className="sunnysoft-service-content">
          <div className="sunnysoft-service-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/>
              <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth="2"/>
              <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3>Enterprise Software</h3>
          <p>Custom AI-driven business applications that optimize operations, predict trends, and enhance productivity with intelligent automation.</p>
          <div className="sunnysoft-service-features">
            <span>AI-Powered CRM Systems</span>
            <span>Predictive Business Intelligence</span>
            <span>Intelligent Workflow Automation</span>
          </div>
        </div>
      </div>
      
      <div className="sunnysoft-service-glass-card sunnysoft-featured">
        <div className="sunnysoft-featured-glow"></div>
        <div className="sunnysoft-service-number sunnysoft-special">02</div>
        <div className="sunnysoft-service-content">
          <div className="sunnysoft-service-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3>Website Development</h3>
          <p>Stunning, responsive websites enhanced with AI to personalize user experiences, optimize conversions, and deliver intelligent functionality.</p>
          <div className="sunnysoft-service-features">
            <span>AI-Driven E-commerce Solutions</span>
            <span>Smart SEO Optimization</span>
            <span>AI-Enhanced Performance</span>
          </div>
        </div>
      </div>
      
      <div className="sunnysoft-service-glass-card">
        <div className="sunnysoft-service-number">03</div>
        <div className="sunnysoft-service-content">
          <div className="sunnysoft-service-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <rect x="5" y="2" width="14" height="20" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
              <line x1="12" y1="18" x2="12.01" y2="18" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3>Mobile Applications</h3>
          <p>AI-powered native and cross-platform mobile apps that engage users with personalized features and drive growth across all devices.</p>
          <div className="sunnysoft-service-features">
            <span>AI-Enhanced iOS & Android Apps</span>
            <span>Intelligent React Native Solutions</span>
            <span>AI-Driven App Store Success</span>
          </div>
        </div>
      </div>
      
      <div className="sunnysoft-service-glass-card">
        <div className="sunnysoft-service-number">04</div>
        <div className="sunnysoft-service-content">
          <div className="sunnysoft-service-icon">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path d="M12 2a10 10 0 0 1 10 10c0 4.4-3.6 8-8 8s-8-3.6-8-8a10 10 0 0 1 10-10z" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 6v12M6 12h12" stroke="currentColor" strokeWidth="2"/>
            </svg>
          </div>
          <h3>AI Implementation</h3>
          <p>Comprehensive AI integration services to enhance any application or system with advanced machine learning, predictive analytics, and automation.</p>
          <div className="sunnysoft-service-features">
            <span>Machine Learning Models</span>
            <span>AI-Powered Analytics</span>
            <span>Custom AI Solutions</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

 {/* Apps Showcase */}
<section id="apps" className="sunnysoft-apps-section">
  <div className="sunnysoft-main-container">
    <div className="sunnysoft-section-header">
      <h2 className="sunnysoft-section-title">Featured Apps</h2>
      <p className="sunnysoft-section-subtitle">Successful applications we've crafted</p>
    </div>
    
    <div className="sunnysoft-apps-showcase">
      <a
        href="https://apps.apple.com/se/app/slutasnusa-fri-fr%C3%A5n-snus/id6746636659"
        target="_blank"
        rel="noopener noreferrer"
        className="sunnysoft-app-glass-card"
        style={{ textDecoration: 'none' }}
      >
        <div className="sunnysoft-app-image-container">
          <img 
            src="/images/quitsnus-icon.png" 
            alt="QuitSnus"
            className="sunnysoft-app-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-app-glow"></div>
        </div>
        <div className="sunnysoft-app-info">
          <h3>QuitSnus</h3>
          <p>Helping thousands quit snus with personalized tracking and motivation</p>
          <div className="sunnysoft-app-stats">
            <div className="sunnysoft-stat-item">
              <span className="sunnysoft-stat-icon">★</span>
              <span>4.8 Rating</span>
            </div>
            <div className="sunnysoft-stat-item">
              <span className="sunnysoft-stat-icon">↓</span>
              <span>10K+ Downloads</span>
            </div>
          </div>
        </div>
      </a>
      
      <a
        href="https://apps.apple.com/us/app/quitsmoking-smoke-free/id6747672052"
        target="_blank"
        rel="noopener noreferrer"
        className="sunnysoft-app-glass-card"
        style={{ textDecoration: 'none' }}
      >
        <div className="sunnysoft-app-image-container">
          <img 
            src="/images/smoking.png" 
            alt="QuitSmoking"
            className="sunnysoft-app-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-app-glow"></div>
        </div>
        <div className="sunnysoft-app-info">
          <h3>QuitSmoking</h3>
          <p>Comprehensive smoking cessation app with proven results</p>
          <div className="sunnysoft-app-stats">
            <div className="sunnysoft-stat-item">
              <span className="sunnysoft-stat-icon">★</span>
              <span>4.9 Rating</span>
            </div>
            <div className="sunnysoft-stat-item">
              <span className="sunnysoft-stat-icon">↓</span>
              <span>25K+ Downloads</span>
            </div>
          </div>
        </div>
      </a>

      <div className="sunnysoft-app-glass-card">
        <div className="sunnysoft-app-image-container">
          <img 
            src="/images/wordlo.png" 
            alt="Wordlo"
            className="sunnysoft-app-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-app-glow"></div>
        </div>
        <div className="sunnysoft-app-info">
          <h3>Wordlo</h3>
          <p>Fun and educational spelling app designed to help children improve their vocabulary and spelling skills</p>
          <div className="sunnysoft-app-stats">
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" stroke="currentColor" strokeWidth="2"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Educational</span>
            </div>
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Kid-Friendly</span>
            </div>
          </div>
        </div>
      </div>

      <div className="sunnysoft-app-glass-card">
        <div className="sunnysoft-app-image-container">
          <img 
            src="/images/numblo.png" 
            alt="Numblo"
            className="sunnysoft-app-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-app-glow"></div>
        </div>
        <div className="sunnysoft-app-info">
          <h3>Numblo</h3>
          <p>Interactive mathematics learning app that makes numbers fun and engaging for young learners</p>
          <div className="sunnysoft-app-stats">
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                <rect x="15" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                <rect x="3" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
                <rect x="15" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Math Learning</span>
            </div>
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                <path d="M12 1v6m0 6v6m11-7h-6m-6 0H1" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Interactive</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

{/* Featured Websites */}
<section id="websites" className="sunnysoft-websites-section">
  <div className="sunnysoft-main-container">
    <div className="sunnysoft-section-header">
      <h2 className="sunnysoft-section-title">Featured Websites</h2>
      <p className="sunnysoft-section-subtitle">Innovative web solutions we've built</p>
    </div>
    
    <div className="sunnysoft-websites-showcase">
      <a
        href="https://sidkollen.se/"
        target="_blank"
        rel="noopener noreferrer"
        className="sunnysoft-website-glass-card"
        style={{ textDecoration: 'none' }}
      >
        <div className="sunnysoft-website-image-container">
          <img 
            src="/images/sidkollen.webp" 
            alt="Sidkollen.se"
            className="sunnysoft-website-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-website-glow"></div>
        </div>
        <div className="sunnysoft-website-info">
          <h3>Sidkollen.se</h3>
          <p>AI-powered e-commerce trustworthiness checker with user reviews to help consumers identify reliable online stores</p>
          <div className="sunnysoft-website-stats">
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>AI-Powered</span>
            </div>
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                <circle cx="12" cy="16" r="1" stroke="currentColor" strokeWidth="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Trust Verified</span>
            </div>
          </div>
        </div>
      </a>
      
      <a
        href="https://elkoll.info/"
        target="_blank"
        rel="noopener noreferrer"
        className="sunnysoft-website-glass-card"
        style={{ textDecoration: 'none' }}
      >
        <div className="sunnysoft-website-image-container">
          <img 
            src="/images/elkoll.png" 
            alt="Elkoll.info"
            className="sunnysoft-website-image"
            onError={(e) => { e.target.src = '/images/fallback.png'; }}
          />
          <div className="sunnysoft-website-glow"></div>
        </div>
        <div className="sunnysoft-website-info">
          <h3>Elkoll.info</h3>
          <p>Real-time electricity price monitoring service providing current energy costs and market insights</p>
          <div className="sunnysoft-website-stats">
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
              <span>Real-time</span>
            </div>
            <div className="sunnysoft-stat-item">
              <svg className="sunnysoft-stat-icon" width="16" height="16" viewBox="0 0 24 24" fill="none">
                <path d="M3 3v5h5" stroke="currentColor" strokeWidth="2"/>
                <path d="M3 21v-5h5" stroke="currentColor" strokeWidth="2"/>
                <path d="M21 3v5h-5" stroke="currentColor" strokeWidth="2"/>
                <path d="M21 21v-5h-5" stroke="currentColor" strokeWidth="2"/>
              </svg>
              <span>Market Data</span>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</section>

      {/* About Section */}
      <section id="about" className="sunnysoft-about-section">
        <div className="sunnysoft-main-container">
          <div className="sunnysoft-about-glass-container">
            <div className="sunnysoft-about-content">
              <div className="sunnysoft-about-text">
                <h2>Why Choose SunnySoft?</h2>
                <p>
                  We're not just another software company. We're your technology partners, 
                  dedicated to transforming your ideas into powerful, scalable solutions that 
                  drive real business results.
                </p>
                <div className="sunnysoft-about-stats">
                  <div className="sunnysoft-stat-glass">
                    <div className="sunnysoft-stat-number">50+</div>
                    <div className="sunnysoft-stat-label">Projects</div>
                  </div>
                  <div className="sunnysoft-stat-glass">
                    <div className="sunnysoft-stat-number">98%</div>
                    <div className="sunnysoft-stat-label">Satisfaction</div>
                  </div>
                  <div className="sunnysoft-stat-glass">
                    <div className="sunnysoft-stat-number">5+</div>
                    <div className="sunnysoft-stat-label">Years</div>
                  </div>
                </div>
              </div>
              
              <div className="sunnysoft-about-features">
                <div className="sunnysoft-feature-glass">
                  <div className="sunnysoft-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <polygon points="13,2 3,14 12,14 11,22 21,10 12,10 13,2" stroke="currentColor" strokeWidth="2" fill="none"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Lightning Fast</h4>
                    <p>Optimized for performance</p>
                  </div>
                </div>
                <div className="sunnysoft-feature-glass">
                  <div className="sunnysoft-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="16" r="1" stroke="currentColor" strokeWidth="2"/>
                      <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Secure & Reliable</h4>
                    <p>Enterprise-grade security</p>
                  </div>
                </div>
                <div className="sunnysoft-feature-glass">
                  <div className="sunnysoft-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                      <circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Results Focused</h4>
                    <p>Measurable outcomes</p>
                  </div>
                </div>
                <div className="sunnysoft-feature-glass">
                  <div className="sunnysoft-feature-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7" stroke="currentColor" strokeWidth="2"/>
                      <path d="M7 7H17V17" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Scalable Solutions</h4>
                    <p>Built to grow</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="sunnysoft-contact-section">
        <div className="sunnysoft-main-container">
          <div className="sunnysoft-contact-glass-card">
            <div className="sunnysoft-contact-info">
              <h2>Let's Build Something Amazing</h2>
              <p>Ready to transform your business with cutting-edge software? Let's discuss your project.</p>
              
              <div className="sunnysoft-contact-methods">
                <div className="sunnysoft-contact-method">
                  <div className="sunnysoft-contact-icon">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" stroke="currentColor" strokeWidth="2"/>
                    </svg>
                  </div>
                  <div>
                    <h4>Quick Response</h4>
                    <p>Reply within 24 hours</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="sunnysoft-contact-form-container">
              <form ref={formRef} onSubmit={handleContactSubmit} className="sunnysoft-contact-form">
                <div className="sunnysoft-form-row">
                  <div className="sunnysoft-form-group">
                    <input
                      type="text"
                      name="from_name"
                      placeholder="Your Name"
                      value={contactForm.name}
                      onChange={(e) => handleContactChange('name', e.target.value)}
                      required
                    />
                  </div>
                  <div className="sunnysoft-form-group">
                    <input
                      type="email"
                      name="from_email"
                      placeholder="Email Address"
                      value={contactForm.email}
                      onChange={(e) => handleContactChange('email', e.target.value)}
                      required
                    />
                  </div>
                </div>
                
                <div className="sunnysoft-form-group">
                  <textarea
                    name="message"
                    placeholder="Tell us about your project..."
                    value={contactForm.message}
                    onChange={(e) => handleContactChange('message', e.target.value)}
                    rows="5"
                    required
                  />
                </div>
                
                <button type="submit" className="sunnysoft-submit-button" disabled={contactStatus === 'loading'}>
                  <span>{contactStatus === 'loading' ? 'Sending...' : 'Send Message'}</span>
                  <div className="sunnysoft-button-shine"></div>
                </button>
                
                {contactStatus === 'success' && (
                  <div className="sunnysoft-form-status sunnysoft-success">Message sent successfully! We'll get back to you soon.</div>
                )}
                {contactStatus === 'error' && (
                  <div className="sunnysoft-form-status sunnysoft-error">Failed to send message. Please try again.</div>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>

  <style jsx>{`
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #e5e7eb;
  color: #1a1a1a;
  line-height: 1.6;
  overflow-x: hidden;
}

.sunnysoft-container {
  min-height: 100vh;
  background: #e5e7eb;
  color: #1a1a1a;
  font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  overflow-x: hidden;
  position: relative;
}

.sunnysoft-container::before {
  content: '';
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(107, 114, 128, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(156, 163, 175, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 40% 80%, rgba(209, 213, 219, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

/* CONSISTENT WIDTH CONTAINER */
.sunnysoft-main-container {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  padding: 0 2rem;
}

/* Navigation */
.sunnysoft-nav-container {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  width: 100%;
  max-width: 1200px;
  padding: 0 2rem;
}

.sunnysoft-nav-content {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(30px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.sunnysoft-nav-logo {
  display: flex;
  align-items: center;
}

.sunnysoft-logo-image {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.1));
  position: absolute;
  left: -1px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.sunnysoft-nav-menu {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.sunnysoft-nav-link {
  background: none;
  border: none;
  color: rgba(26, 26, 26, 0.7);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.95rem;
  padding: 0.5rem 0;
  position: relative;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-nav-link:hover {
  color: #1a1a1a;
}

.sunnysoft-nav-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background: #4b5563;
  transition: width 0.3s ease;
}

.sunnysoft-nav-link:hover::after {
  width: 100%;
}

.sunnysoft-language-container {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 8px;
  padding: 0.5rem;
  backdrop-filter: blur(10px);
}

.sunnysoft-language-select {
  background: none;
  border: none;
  color: #1a1a1a;
  font-size: 0.9rem;
  cursor: pointer;
  outline: none;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-language-select option {
  background: #ffffff;
  color: #1a1a1a;
}

.sunnysoft-menu-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
}

.sunnysoft-menu-toggle span {
  width: 25px;
  height: 2px;
  background: #1a1a1a;
  transition: all 0.3s ease;
}

/* Hero Section */
.sunnysoft-hero-section {
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 120px 2rem 20px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.sunnysoft-hero-background {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
}

.sunnysoft-floating-orb {
  position: absolute;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  animation: float 6s ease-in-out infinite;
}

.sunnysoft-orb-1 {
  width: 100px;
  height: 100px;
  top: 20%;
  left: 10%;
  animation-delay: 0s;
}

.sunnysoft-orb-2 {
  width: 60px;
  height: 60px;
  top: 60%;
  right: 15%;
  animation-delay: 2s;
}

.sunnysoft-orb-3 {
  width: 80px;
  height: 80px;
  bottom: 20%;
  left: 20%;
  animation-delay: 4s;
}

.sunnysoft-orb-4 {
  width: 40px;
  height: 40px;
  top: 30%;
  right: 30%;
  animation-delay: 1s;
}

.sunnysoft-hero-glass-card {
  background: linear-gradient(135deg, 
    rgba(59, 130, 246, 0.15) 0%,
    rgba(255, 255, 255, 0.2) 30%,
    rgba(147, 51, 234, 0.12) 100%);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 30px;
  padding: 2.5rem;
  text-align: center;
  position: relative;
  z-index: 10;
  width: 100%;
}

.sunnysoft-hero-badge {
  display: inline-block;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #1a1a1a;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 1rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-hero-title {
  font-size: 4rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 1rem;
  letter-spacing: -0.02em;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-hero-accent {
  color: #4b5563;
}

.sunnysoft-hero-subtitle {
  font-size: 1.3rem;
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.6;
  margin-bottom: 1.5rem;
  max-width: 90%;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-hero-cta {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  flex-wrap: wrap;
}

.sunnysoft-cta-primary {
  background: rgba(75, 85, 99, 0.9);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(75, 85, 99, 1);
  color: #ffffff;
  padding: 1.2rem 2.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-cta-primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 20px 40px rgba(75, 85, 99, 0.3);
  background: rgba(75, 85, 99, 1);
}

.sunnysoft-cta-secondary {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #1a1a1a;
  padding: 1.2rem 2.5rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-cta-secondary:hover {
  background: rgba(255, 255, 255, 0.3);
  border-color: rgba(255, 255, 255, 0.4);
  transform: translateY(-3px);
}

.sunnysoft-button-shine {
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s;
}

.sunnysoft-cta-primary:hover .sunnysoft-button-shine {
  left: 100%;
}

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-20px) rotate(180deg); }
}

/* ALL SECTIONS */
.sunnysoft-services-section, 
.sunnysoft-apps-section, 
.sunnysoft-websites-section,
.sunnysoft-about-section, 
.sunnysoft-contact-section {
  padding: 30px 0;
  position: relative;
  z-index: 5;
}

/* SECTION HEADERS */
.sunnysoft-section-header {
  text-align: center;
  margin-bottom: 2rem;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 2rem;
}

.sunnysoft-section-title {
  font-size: 3rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
  letter-spacing: -0.02em;
}

.sunnysoft-section-subtitle {
  font-size: 1.2rem;
  color: rgba(26, 26, 26, 0.7);
  font-family: 'Poppins', sans-serif;
}

/* Services Grid */
.sunnysoft-services-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  width: 100%;
}

.sunnysoft-service-glass-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 1.5rem;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  min-width: 0;
}

.sunnysoft-service-glass-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(75, 85, 99, 0.15);
  background: rgba(255, 255, 255, 0.25);
}

.sunnysoft-service-glass-card.sunnysoft-featured {
  background: rgba(255, 255, 255, 0.2);
}

.sunnysoft-featured-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(75, 85, 99, 0.05);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.sunnysoft-service-glass-card.sunnysoft-featured:hover .sunnysoft-featured-glow {
  opacity: 1;
}

.sunnysoft-service-number {
  font-size: 3rem;
  font-weight: 100;
  color: rgba(26, 26, 26, 0.06);
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-service-number.sunnysoft-special {
  color: rgba(75, 85, 99, 0.12);
}

.sunnysoft-service-content {
  position: relative;
  z-index: 2;
}

.sunnysoft-service-icon {
  color: #4b5563;
  margin-bottom: 1rem;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.sunnysoft-service-glass-card h3 {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-service-glass-card p {
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.5;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-service-features {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.sunnysoft-service-features span {
  font-size: 0.8rem;
  color: rgba(26, 26, 26, 0.6);
  position: relative;
  padding-left: 1rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-service-features span::before {
  content: '•';
  position: absolute;
  left: 0;
  color: #4b5563;
}

/* Websites Showcase */
.sunnysoft-websites-showcase {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 3rem;
}

.sunnysoft-website-glass-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 2.5rem;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.sunnysoft-website-glass-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(75, 85, 99, 0.15);
  background: rgba(255, 255, 255, 0.25);
}

.sunnysoft-website-image-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 2rem;
}

.sunnysoft-website-image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  object-fit: cover;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.15));
}

.sunnysoft-website-glow {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: rgba(75, 85, 99, 0.12);
  border-radius: 25px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.sunnysoft-website-glass-card:hover .sunnysoft-website-glow {
  opacity: 1;
}

.sunnysoft-website-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-website-info p {
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-website-stats {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

/* Apps Showcase */
.sunnysoft-apps-showcase {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
}

.sunnysoft-app-glass-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 25px;
  padding: 2.5rem;
  transition: all 0.4s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.sunnysoft-app-glass-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 30px 60px rgba(75, 85, 99, 0.15);
  background: rgba(255, 255, 255, 0.25);
}

.sunnysoft-app-image-container {
  position: relative;
  width: 100px;
  height: 100px;
  margin-bottom: 2rem;
}

.sunnysoft-app-image {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  object-fit: cover;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.15));
}

.sunnysoft-app-glow {
  position: absolute;
  top: -10px;
  left: -10px;
  right: -10px;
  bottom: -10px;
  background: rgba(75, 85, 99, 0.12);
  border-radius: 25px;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.sunnysoft-app-glass-card:hover .sunnysoft-app-glow {
  opacity: 1;
}

.sunnysoft-app-info h3 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-app-info p {
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.6;
  margin-bottom: 1.5rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-app-stats {
  display: flex;
  gap: 2rem;
  justify-content: center;
}

.sunnysoft-stat-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.9rem;
  color: rgba(26, 26, 26, 0.7);
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-stat-icon {
  font-size: 1.1rem;
  color: #4b5563;
}

/* About Section */
.sunnysoft-about-glass-container {
  width: 100%;
}

.sunnysoft-about-content {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  padding: 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.sunnysoft-about-text h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
  letter-spacing: -0.02em;
}

.sunnysoft-about-text p {
  font-size: 1.2rem;
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.6;
  margin-bottom: 2rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-about-stats {
  display: flex;
  gap: 2rem;
}

.sunnysoft-stat-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 1.5rem;
  text-align: center;
  flex: 1;
}

.sunnysoft-stat-number {
  font-size: 2.5rem;
  font-weight: 700;
  color: #4b5563;
  margin-bottom: 0.5rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-stat-label {
  color: rgba(26, 26, 26, 0.7);
  font-weight: 500;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-about-features {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.sunnysoft-feature-glass {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  transition: all 0.3s ease;
}

.sunnysoft-feature-glass:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: translateX(10px);
}

.sunnysoft-feature-icon {
  color: #4b5563;
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sunnysoft-feature-glass h4 {
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-feature-glass p {
  color: rgba(26, 26, 26, 0.7);
  font-size: 0.95rem;
  margin: 0;
  font-family: 'Poppins', sans-serif;
}

/* Contact Section */
.sunnysoft-contact-glass-card {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(25px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  padding: 4rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  width: 100%;
}

.sunnysoft-contact-info h2 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
  letter-spacing: -0.02em;
}

.sunnysoft-contact-info p {
  font-size: 1.2rem;
  color: rgba(26, 26, 26, 0.7);
  line-height: 1.6;
  margin-bottom: 2rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-contact-methods {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.sunnysoft-contact-method {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 15px;
  padding: 1.5rem;
}

.sunnysoft-contact-icon {
  color: #4b5563;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sunnysoft-contact-method h4 {
  font-weight: 600;
  margin-bottom: 0.25rem;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-contact-method p {
  color: rgba(26, 26, 26, 0.7);
  margin: 0;
  font-size: 0.95rem;
  font-family: 'Poppins', sans-serif;
}

/* Contact Form */
.sunnysoft-contact-form-container {
  width: 100%;
}

.sunnysoft-contact-form {
  background: rgba(255, 255, 255, 0.15);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 3rem;
  width: 100%;
}

.sunnysoft-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.sunnysoft-form-group {
  margin-bottom: 1.5rem;
  width: 100%;
}

.sunnysoft-form-group input,
.sunnysoft-form-group textarea {
  width: 100%;
  padding: 1.2rem;
  background: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  font-size: 1rem;
  color: #1a1a1a;
  transition: all 0.3s ease;
  resize: vertical;
  box-sizing: border-box;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-form-group input::placeholder,
.sunnysoft-form-group textarea::placeholder {
  color: rgba(26, 26, 26, 0.5);
}

.sunnysoft-form-group input:focus,
.sunnysoft-form-group textarea:focus {
  outline: none;
  border-color: #4b5563;
  background: rgba(255, 255, 255, 0.35);
  box-shadow: 0 0 0 3px rgba(75, 85, 99, 0.1);
}

.sunnysoft-submit-button {
  background: rgba(75, 85, 99, 0.9);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(75, 85, 99, 1);
  color: #ffffff;
  padding: 1.2rem 2rem;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-submit-button:hover:not(:disabled) {
  transform: translateY(-3px);
  box-shadow: 0 20px 40px rgba(75, 85, 99, 0.3);
  background: rgba(75, 85, 99, 1);
}

.sunnysoft-submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sunnysoft-form-status {
  margin-top: 1rem;
  padding: 1rem;
  border-radius: 12px;
  text-align: center;
  font-weight: 500;
  backdrop-filter: blur(10px);
  font-family: 'Poppins', sans-serif;
}

.sunnysoft-form-status.sunnysoft-success {
  background: rgba(34, 197, 94, 0.2);
  color: #166534;
  border: 1px solid rgba(34, 197, 94, 0.3);
}

.sunnysoft-form-status.sunnysoft-error {
  background: rgba(239, 68, 68, 0.2);
  color: #991b1b;
  border: 1px solid rgba(239, 68, 68, 0.3);
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .sunnysoft-main-container {
    padding: 0 1rem;
  }

  .sunnysoft-nav-container {
    padding: 0 1rem;
  }

  .sunnysoft-nav-content {
    padding: 0.75rem 1rem;
  }

  .sunnysoft-logo-image {
    width: 50px;
    height: 50px;
  }

  .sunnysoft-nav-menu {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%) translateY(-20px);
    width: calc(100vw - 2rem);
    max-width: 1200px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(30px);
    border: 1px solid rgba(255, 255, 255, 0.8);
    border-radius: 20px;
    flex-direction: column;
    padding: 1.5rem;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s ease;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  }

  .sunnysoft-nav-menu.sunnysoft-nav-menu-open {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .sunnysoft-menu-toggle {
    display: flex;
  }

  .sunnysoft-hero-section {
    padding: 100px 1rem 15px;
    margin: 0;
  }

  .sunnysoft-hero-glass-card {
    padding: 1.5rem;
    margin: 0;
  }

  .sunnysoft-hero-title {
    font-size: 2.2rem;
  }

  .sunnysoft-hero-subtitle {
    font-size: 1rem;
  }

  .sunnysoft-hero-cta {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  .sunnysoft-cta-primary,
  .sunnysoft-cta-secondary {
    width: 100%;
    max-width: 280px;
    padding: 1rem 2rem;
  }

  .sunnysoft-section-header {
    padding: 0 1rem;
  }

  .sunnysoft-services-section,
  .sunnysoft-apps-section,
  .sunnysoft-websites-section,
  .sunnysoft-about-section,
  .sunnysoft-contact-section {
    padding: 25px 0;
  }

  .sunnysoft-section-title {
    font-size: 1.8rem;
  }

  .sunnysoft-services-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .sunnysoft-service-glass-card {
    padding: 1.25rem;
  }

  .sunnysoft-service-number {
    font-size: 2.5rem;
  }

  .sunnysoft-service-glass-card h3 {
    font-size: 1.1rem;
  }

  .sunnysoft-service-glass-card p {
    font-size: 0.8rem;
  }

  .sunnysoft-service-features span {
    font-size: 0.75rem;
  }

  .sunnysoft-apps-showcase {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  .sunnysoft-app-glass-card {
    padding: 1.25rem;
  }

  .sunnysoft-app-image-container {
    width: 80px;
    height: 80px;
    margin-bottom: 1rem;
  }

  .sunnysoft-websites-showcase {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .sunnysoft-website-glass-card {
    padding: 1.5rem;
  }

  .sunnysoft-about-content {
    grid-template-columns: 1fr;
    gap: 2rem;
    padding: 1.5rem;
  }

  .sunnysoft-about-stats {
    justify-content: center;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .sunnysoft-stat-glass {
    padding: 1rem;
  }

  .sunnysoft-feature-glass {
    padding: 1rem;
  }

  .sunnysoft-contact-glass-card {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding: 1.5rem;
  }

  .sunnysoft-contact-form {
    padding: 1.5rem;
  }

  .sunnysoft-form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-bottom: 1rem;
  }

  .sunnysoft-form-group {
    margin-bottom: 1rem;
  }

  .sunnysoft-form-group input,
  .sunnysoft-form-group textarea {
    padding: 1rem;
  }
}

@media (max-width: 480px) {
  .sunnysoft-logo-image {
    width: 45px;
    height: 45px;
  }

  .sunnysoft-hero-section {
    padding: 90px 1rem 15px;
  }

  .sunnysoft-hero-glass-card {
    padding: 1.25rem;
  }

  .sunnysoft-hero-title {
    font-size: 1.8rem;
  }

  .sunnysoft-hero-subtitle {
    font-size: 0.95rem;
  }

  .sunnysoft-services-section,
  .sunnysoft-apps-section,
  .sunnysoft-websites-section,
  .sunnysoft-about-section,
  .sunnysoft-contact-section {
    padding: 20px 0;
  }

  .sunnysoft-section-title {
    font-size: 1.6rem;
  }

  .sunnysoft-services-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .sunnysoft-service-glass-card {
    padding: 1rem;
  }

  .sunnysoft-service-number {
    font-size: 2rem;
  }

  .sunnysoft-service-glass-card h3 {
    font-size: 1rem;
  }

  .sunnysoft-service-glass-card p {
    font-size: 0.75rem;
  }

  .sunnysoft-service-features span {
    font-size: 0.7rem;
  }

  .sunnysoft-apps-showcase {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .sunnysoft-websites-showcase {
    grid-template-columns: 1fr;
    gap: 1rem;
  }

  .sunnysoft-service-glass-card,
  .sunnysoft-app-glass-card,
  .sunnysoft-website-glass-card {
    padding: 1.25rem;
  }

  .sunnysoft-about-content,
  .sunnysoft-contact-glass-card {
    padding: 1.25rem;
  }

  .sunnysoft-contact-form {
    padding: 1.25rem;
  }

  .sunnysoft-about-stats {
    flex-direction: column;
    gap: 0.75rem;
  }

  .sunnysoft-stat-glass {
    padding: 0.75rem;
  }

  .sunnysoft-feature-glass {
    padding: 0.75rem;
    gap: 0.75rem;
  }

  .sunnysoft-about-text h2 {
    font-size: 1.6rem;
  }

  .sunnysoft-contact-info h2 {
    font-size: 1.6rem;
  }

  .sunnysoft-form-group input,
  .sunnysoft-form-group textarea {
    padding: 0.875rem;
  }
}

/* ORIGINAL APP PAGES CSS */
.app-page-container {
  min-height: 100vh;
  background: #fafafa;
  padding: 1rem;
  width: 100%;
  font-family: 'Poppins', sans-serif;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: white;
  color: #666;
  text-decoration: none;
  padding: 0.75rem 1.25rem;
  border-radius: 12px;
  font-weight: 500;
  transition: all 0.2s ease;
  margin-bottom: 2rem;
  border: 1px solid #e5e5e5;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
}

.back-btn:hover {
  background: #f8f8f8;
  color: #1a1a1a;
  border-color: #d0d0d0;
}

.app-hero {
  background: white;
  border-radius: 20px;
  padding: 3rem 2rem;
  margin-bottom: 3rem;
  border: 1px solid #e5e5e5;
  text-align: center;
  width: 100%;
}

.app-icon-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
  margin-bottom: 2.5rem;
}

.app-hero-icon {
  width: 100px;
  height: 100px;
  border-radius: 22px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.app-hero-icon:hover {
  transform: scale(1.02);
}

.app-info {
  text-align: left;
}

.app-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  letter-spacing: -0.02em;
  font-family: 'Poppins', sans-serif;
}

.app-rating {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.star {
  color: #ff9500;
  font-size: 1.2rem;
}

.rating-text {
  font-weight: 600;
  color: #666;
  margin-left: 0.25rem;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
}

.app-subtitle {
  font-size: 1.1rem;
  color: #666;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
}

.coming-soon-badge {
  background: #ff9500;
  color: white;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 1rem;
  display: inline-block;
  animation: pulse 2s infinite;
  font-family: 'Poppins', sans-serif;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}

.download-section {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}

.download-button {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  background: #1a1a1a;
  color: white;
  text-decoration: none;
  padding: 1rem 1.5rem;
  border-radius: 14px;
  transition: all 0.2s ease;
  font-size: 0.9rem;
  font-family: 'Poppins', sans-serif;
}

.download-button.android {
  background: #34a853;
}

.download-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.download-icon {
  font-size: 1.5rem;
}

.download-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.download-label {
  font-size: 0.75rem;
  opacity: 0.8;
}

.download-store {
  font-size: 1rem;
  font-weight: 600;
}

.app-main-content {
  width: 100%;
}

.about-section {
  background: white;
  padding: 2.5rem;
  border-radius: 20px;
  border: 1px solid #e5e5e5;
  width: 100%;
}

.section-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 1.5rem;
  letter-spacing: -0.02em;
  font-family: 'Poppins', sans-serif;
}

.about-text p {
  font-size: 1rem;
  line-height: 1.7;
  color: #666;
  margin-bottom: 1.25rem;
  font-family: 'Poppins', sans-serif;
}

.policy-section {
  margin-bottom: 2rem;
}

.policy-section .section-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.policy-section .about-text {
  margin-bottom: 1.5rem;
}

.features-showcase {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.25rem;
  margin-top: 2.5rem;
}

.feature-showcase-card {
  background: #f8f8f8;
  padding: 1.5rem;
  border-radius: 16px;
  text-align: center;
  transition: all 0.2s ease;
  border: 1px solid transparent;
}

.feature-showcase-card:hover {
  background: white;
  border-color: #e5e5e5;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
}

.feature-showcase-icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
}

.feature-showcase-title {
  font-size: 1rem;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 0.25rem;
  font-family: 'Poppins', sans-serif;
}

.feature-showcase-desc {
  color: #666;
  font-size: 0.85rem;
  line-height: 1.4;
  font-family: 'Poppins', sans-serif;
}

.screenshots-section {
  position: relative;
}

.phone-mockup {
  position: relative;
  height: 500px;
  background: white;
  border-radius: 20px;
  border: 1px solid #e5e5e5;
  padding: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.screenshot-slide {
  position: absolute;
  width: 160px;
  height: 320px;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  background: #1a1a1a;
  padding: 8px;
  opacity: 0;
  transform: translateY(30px) rotate(2deg);
  transition: all 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

.screenshot-slide:nth-child(1) {
  top: 50px;
  left: 50px;
  z-index: 4;
  transition-delay: 0s;
}

.screenshot-slide:nth-child(2) {
  top: 80px;
  left: 80px;
  z-index: 3;
  transition-delay: 0.1s;
}

.screenshot-slide:nth-child(3) {
  top: 110px;
  left: 110px;
  z-index: 2;
  transition-delay: 0.2s;
}

.screenshot-slide:nth-child(4) {
  top: 140px;
  left: 140px;
  z-index: 1;
  transition-delay: 0.3s;
}

.screenshot-slide.visible {
  opacity: 1;
  transform: translateY(0) rotate(0deg);
}

.screenshot-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}

.language-switcher {
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 1000;
}

.language-select {
  padding: 0.5rem 1rem;
  border-radius: 10px;
  border: 1px solid #e5e5e5;
  background: white;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #666;
  font-family: 'Poppins', sans-serif;
}

.language-select:hover {
  border-color: #d0d0d0;
  color: #1a1a1a;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
  font-family: 'Poppins', sans-serif;
}

.hero-section {
  text-align: center;
  padding: 2rem 0;
}

.brand-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  margin-bottom: 2rem;
}

.brand-icon {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  object-fit: cover;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

.brand-icon:hover {
  transform: scale(1.05);
}

.brand-title {
  font-size: 3rem;
  font-weight: 700;
  color: #1a1a1a;
  letter-spacing: -0.02em;
  font-family: 'Poppins', sans-serif;
}

.hero-subtitle {
  font-size: 1.25rem;
  color: #666;
  margin-bottom: 3rem;
  font-weight: 400;
  font-family: 'Poppins', sans-serif;
}

.apps-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;
}

.app-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  padding: 2rem;
  background: white;
  border-radius: 20px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
  text-decoration: none;
  color: inherit;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #e5e5e5;
  position: relative;
}

.app-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  border-color: #d0d0d0;
}

.app-icon-container {
  position: relative;
  overflow: hidden;
  border-radius: 18px;
}

.app-icon {
  width: 80px;
  height: 80px;
  border-radius: 18px;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.app-card:hover .app-icon {
  transform: scale(1.1);
}

.app-name {
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a1a1a;
  font-family: 'Poppins', sans-serif;
}

.contact-section {
  max-width: 600px;
  margin: 0 auto;
  width: 100%;
}

.contact-header {
  text-align: center;
  margin-bottom: 2rem;
}

.contact-header h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 0.5rem;
  letter-spacing: -0.01em;
  font-family: 'Poppins', sans-serif;
}

.contact-header p {
  font-size: 1.1rem;
  color: #666;
  font-family: 'Poppins', sans-serif;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  background: white;
  padding: 2rem;
  border-radius: 20px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
  border: 1px solid #e5e5e5;
}

.form-group {
  position: relative;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  font-size: 1rem;
  font-family: 'Poppins', sans-serif;
  background: #fafafa;
  transition: all 0.3s ease;
  resize: none;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #1a1a1a;
  background: white;
  box-shadow: 0 0 0 3px rgba(26, 26, 26, 0.1);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: #999;
}

.submit-btn {
  background: #1a1a1a;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  align-self: center;
  min-width: 150px;
  font-family: 'Poppins', sans-serif;
}

.submit-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 25px rgba(26, 26, 26, 0.2);
}

.submit-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.form-status {
  text-align: center;
  padding: 0.75rem;
  border-radius: 8px;
  font-weight: 500;
  font-family: 'Poppins', sans-serif;
}

.form-status.success {
  background: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.form-status.error {
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}

.footer {
  text-align: center;
  padding: 3rem 0 2rem;
  border-top: 1px solid #eee;
  margin-top: auto;
}

.footer-copyright {
  color: #999;
  font-size: 0.85rem;
  font-family: 'Poppins', sans-serif;
}

    
      `}</style>
    </div>
  );
};

export default LandingPage;